import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableConfigurationRoutes = Loadable(
  './ConfigurationRoutes',
  () => import(/* webpackChunkName: "Configuration" */ './ConfigurationRoutes'),
  () => [(require as any).resolveWeak('./ConfigurationRoutes')]
);